/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSimpliCity } from "@simplicitycms/simplicity-common";

const useFeatureFlag = (key) => {
    const { settings } = useSimpliCity();
    const textFlag = settings[key];
    // console.log(`Feature Flag: ${key} = ${textFlag}`);
    return textFlag === "true";
};

export { useFeatureFlag };
